export default __webpack_public_path__ + "static/media/raccoonpng.27b87999.png";